import { render, staticRenderFns } from "./DashboardSessionsTable.vue?vue&type=template&id=1bfc87c9&scoped=true&"
import script from "./DashboardSessionsTable.vue?vue&type=script&lang=js&"
export * from "./DashboardSessionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfc87c9",
  null
  
)

export default component.exports